<template>
    <div class="kedvezmenyek-base">
            <slot name="kedvezmeny"></slot>
    </div>
</template>

<script>
export default {
    name: 'KedvezmenyBase',
};
</script>

<style>

    .kedvezmenyek-base {
        width: 100%;
    }
</style>
